
import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class UsersService {
   domainProperty: any;
 
   jsonConfigData(){
    
  //  var  logger = new Subject<boolean>();
  //   var jsonData:any ;
  //   var storedData = localStorage.getItem("md_jsonDomainProperty");
  //   jsonData= await firstValueFrom(this.httpCall.get<any>("assets/domainProperty.json"));
  //   if (storedData) {
  //     JSON.parse(localStorage.getItem("md_jsonDomainProperty")).filter(domainName => {

  //     environment.productCode = domainName.productCode;
  //     console.log('environment.productCode :', environment.productCode);
  //     environment.Base_url = domainName.apiUrl;
  //      environment.baseUrl = domainName.apiUrl1;
  //      environment.baseUrl1 = domainName.apiUrl2;
  //      environment.urlForDynamicForm=domainName.baseUrlForDropdown;
  //      environment.urlForDocumentReUpload=domainName.documentReUpload
  //      environment.coreIntegrator=domainName.apiForCoreIntegrator;
  //      environment.apiForMaps = domainName.apiForMaps;
  //      environment.productCode = domainName.productCode;
  //      environment.redirectPath=domainName.redirectPath;
  //      // Dashboard Configuration
  //      environment.instaODURL =			domainName.dashboard.instaODURL ,
  //      environment.IciciBase_url =			domainName.dashboard.IciciBase_url ,
  //      environment.Authkey=				domainName.dashboard.Authkey,
  //      environment.Merchant_Base_url=		domainName.dashboard.Merchant_Base_url,
  //      environment.GeniusCrm_Base_url=		domainName.dashboard.GeniusCrm_Base_url,
  //      environment.geniusCrm =				domainName.dashboard.geniusCrm ,
  //      environment.Entity_Id=				domainName.dashboard.Entity_Id,
  //      environment.Merchant_requestorId=	domainName.dashboard.Merchant_requestorId,
  //      environment.Merchant_inputterId=	domainName.dashboard.Merchant_inputterId,
  //      environment.Merchant_ipAddress=		domainName.dashboard.Merchant_ipAddress,
  //      environment.Merchant_approverId=	domainName.dashboard.Merchant_approverId,
  //      environment.Merchant_ticketId=		domainName.dashboard.Merchant_ticketId,
  //      environment.Merchant_clientSecret=	domainName.dashboard.Merchant_clientSecret,
  //      environment.Merchant_clientId=		domainName.dashboard.Merchant_clientId,
  //      environment.Merchant_Id=			domainName.dashboard.Moerchant_Id,
  //      environment.qr_upiMerchantId =		domainName.dashboard.qr_upiMerchantId ,
  //      environment.qr_payModeId =			domainName.dashboard.qr_payModeId ,
  //      environment.merchantOnboardUrl =	domainName.dashboard.merchantOnboardUrl ,
  //      environment.emailNotification =		domainName.dashboard.emailNotification ,
  //      environment.production=				domainName.dashboard.production,
  //      environment.rbacUrl = domainName.dashboard.rbacUrl,
  //      environment.errorPage = domainName.dashboard.errorPage
  //     });
  //     await setTimeout(()=>{
  //       //  this.userService.funSessionExpired(res?.statusDesc);
  //                    },5000)
  //     return Promise.resolve(JSON.parse(storedData));

  //   } else {
  //     this.jsonProperty = await jsonData.filter(domainName => {
  //         environment.productCode = domainName.productCode;
  //        environment.productCode = domainName.productCode;
  //         environment.Base_url = domainName.apiUrl;
  //         environment.baseUrl = domainName.apiUrl1;
  //         environment.baseUrl1 = domainName.apiUrl2;
  //         environment.urlForDynamicForm=domainName.baseUrlForDropdown;
  //         environment.urlForDocumentReUpload=domainName.documentReUpload
  //         environment.coreIntegrator=domainName.apiForCoreIntegrator;
  //         environment.apiForMaps = domainName.apiForMaps;
  //         environment.productCode = domainName.productCode;
  //         environment.redirectPath=domainName.redirectPath;
  //         // Dashboard Configuration
  //         environment.instaODURL =			domainName.dashboard.instaODURL ,
  //         environment.IciciBase_url =			domainName.dashboard.IciciBase_url ,
  //         environment.Authkey=				domainName.dashboard.Authkey,
  //         environment.Merchant_Base_url=		domainName.dashboard.Merchant_Base_url,
  //         environment.GeniusCrm_Base_url=		domainName.dashboard.GeniusCrm_Base_url,
  //         environment.geniusCrm =				domainName.dashboard.geniusCrm ,
  //         environment.Entity_Id=				domainName.dashboard.Entity_Id,
  //         environment.Merchant_requestorId=	domainName.dashboard.Merchant_requestorId,
  //         environment.Merchant_inputterId=	domainName.dashboard.Merchant_inputterId,
  //         environment.Merchant_ipAddress=		domainName.dashboard.Merchant_ipAddress,
  //         environment.Merchant_approverId=	domainName.dashboard.Merchant_approverId,
  //         environment.Merchant_ticketId=		domainName.dashboard.Merchant_ticketId,
  //         environment.Merchant_clientSecret=	domainName.dashboard.Merchant_clientSecret,
  //         environment.Merchant_clientId=		domainName.dashboard.Merchant_clientId,
  //         environment.Merchant_Id=			domainName.dashboard.Moerchant_Id,
  //         environment.qr_upiMerchantId =		domainName.dashboard.qr_upiMerchantId ,
  //         environment.qr_payModeId =			domainName.dashboard.qr_payModeId ,
  //         environment.merchantOnboardUrl =	domainName.dashboard.merchantOnboardUrl ,
  //         environment.emailNotification =		domainName.dashboard.emailNotification ,
  //         environment.production=				domainName.dashboard.production,
  //         environment.rbacUrl = domainName.dashboard.rbacUrl,
  //         environment.errorPage = domainName.dashboard.errorPage

  //     })
  //     this.Base_url = environment.IciciBase_url;
  //     this.rbacUrl = environment.rbacUrl;
  //     this.GeniusCrm_Base_url = environment.GeniusCrm_Base_url;
  //     console.log(this.Base_url);
  //     console.log(this.GeniusCrm_Base_url);
  //     console.log('environment : ',environment);
  //     localStorage.setItem('md_jsonData',JSON.stringify(jsonData))


  //     localStorage.setItem("md_jsonDomainProperty", JSON.stringify(this.jsonConfig));

  //   if(localStorage.getItem('md_jsonDomainProperty')){
  //     this.domainProperty = JSON.parse(localStorage.getItem('md_jsonDomainProperty'))[0];
  //   }
  //   console.log('res : ',jsonData);
  //   return jsonData;
  // }

  }


 

}

